module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "summer"
    }
  }, [_c('h1', [_vm._v("Summer")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("The lawns have been mowed, they look really great")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("’Twas a very hot job done by my mate")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("They grow so fast even though there’s no rain")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("I don’t know why, but it is such a pain")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("The edges are done, and the garden is weeded")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("A good daily watering is now needed")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("It’s a delight to see the flowers so bright")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("And the new added gardens complete the sight")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Actually, there’re still more gardens to come")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("And the bed for the bulbs is now nearly done")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("But alas! We are not happy when the temperature is high")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("And then when it’s wet and windy, we sigh")]), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("We must learn to be happy, whatever the case")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-indent": "00em"
    }
  }, [_vm._v("Whether it’s sun, wind, or rain in our face")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e8ebb36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch007.vue
// module id = 81
// module chunks = 0